import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

import ContentContainer from '../../common/ContentContainer';
import BlockHeader from '../../common/BlockHeader';

import { ReactComponent as UserIcon } from '../../../assets/clan/overallStats/user.svg';
import { ReactComponent as IsleIcon } from '../../../assets/clan/overallStats/isle.svg';
import { ReactComponent as PvpIcon } from '../../../assets/clan/overallStats/pvp.svg';
import { ReactComponent as WlknIcon } from '../../../assets/clan/overallStats/wlkn.svg';
import { useDataState } from '../../../providers/DataProvider.hooks';

export const OverallStats = () => {
    const { selectedClan, clanMembers } = useDataState();
    const clanStats = useMemo(() => {
        if (selectedClan && clanMembers) {
            const selectedClanMembers = clanMembers.data.filter((memeber) => memeber.clan === selectedClan.clan);
            let pvpWins = 0;
            let isleClashWins = 0;
            let totalEarnings = 0;
            selectedClanMembers.forEach((member) => {
                pvpWins += member.win_pvp;
                isleClashWins += member.win_isl;
                totalEarnings += member.wlkn_pvp + member.wlkn_isl;
            });
            return {
                pvpWins,
                isleClashWins,
                totalEarnings,
                members: selectedClanMembers.length,
            };
        }
    }, [selectedClan, clanMembers]);

    return (
        <ContentContainer colorBg>
            <Box
                display={'flex'}
                justifyContent={'space-between'}
                sx={{
                    marginTop: '80px',
                    marginBottom: '20px',
                }}
            >
                <Box>
                    <BlockHeader text="Overall Stats"></BlockHeader>
                </Box>
            </Box>
            <Box
                sx={{
                    borderRadius: '20px',
                    backgroundColor: '#fff',
                    display: 'flex',
                    padding: '30px',
                }}
            >
                <Box display={'flex'} gap="15px" width={'100%'}>
                    <UserIcon />
                    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                        <Typography
                            sx={{
                                color: '#9298A1',
                                fontFamily: 'AvenirNext400',
                                fontSize: '14px',
                            }}
                        >
                            Purr-sonalities
                        </Typography>
                        <Typography
                            sx={{
                                color: '#0F0E0E',
                                fontFamily: 'AvenirNext700',
                                fontSize: '24px',
                            }}
                        >
                            {clanStats?.members}
                        </Typography>
                    </Box>
                </Box>
                <Box display={'flex'} gap="15px" width={'100%'}>
                    <PvpIcon />
                    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                        <Typography
                            sx={{
                                color: '#9298A1',
                                fontFamily: 'AvenirNext400',
                                fontSize: '14px',
                            }}
                        >
                            PvP wins
                        </Typography>
                        <Typography
                            sx={{
                                color: '#0F0E0E',
                                fontFamily: 'AvenirNext700',
                                fontSize: '24px',
                            }}
                        >
                            {clanStats && Number(clanStats?.pvpWins.toFixed()).toLocaleString('en-US')}
                        </Typography>
                    </Box>
                </Box>
                <Box display={'flex'} gap="15px" width={'100%'}>
                    <IsleIcon />
                    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                        <Typography
                            sx={{
                                color: '#9298A1',
                                fontFamily: 'AvenirNext400',
                                fontSize: '14px',
                            }}
                        >
                            Isle Clash wins
                        </Typography>
                        <Typography
                            sx={{
                                color: '#0F0E0E',
                                fontFamily: 'AvenirNext700',
                                fontSize: '24px',
                            }}
                        >
                            {clanStats && Number(clanStats?.isleClashWins.toFixed()).toLocaleString('en-US')}
                        </Typography>
                    </Box>
                </Box>
                <Box display={'flex'} gap="15px" width={'100%'}>
                    <WlknIcon />
                    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                        <Typography
                            sx={{
                                color: '#9298A1',
                                fontFamily: 'AvenirNext400',
                                fontSize: '14px',
                            }}
                        >
                            Total earnings
                        </Typography>
                        <Typography
                            sx={{
                                color: '#0F0E0E',
                                fontFamily: 'AvenirNext700',
                                fontSize: '24px',
                            }}
                        >
                            {clanStats && Number(clanStats?.totalEarnings.toFixed()).toLocaleString('en-US')}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </ContentContainer>
    );
};
